import { createAction, props } from '@ngrx/store';

import { TenantSettingsModel } from '@main-application/management/pages/turnover-configuration/components/turnover-configuration-elapsed-days-section/models/config.models';
import { RestPropertyModel } from '@shared/interfaces/rest-portfolio-model.interface';
import { TenantData } from '@shared/interfaces/tenant-data';
import { UserData } from '@shared/interfaces/user-data';

export const loadTenantData = createAction('[App][Core] Load tenant data');
export const loadUserTenantSucceeded = createAction('[App][Core] Load tenant data succeeded', props<TenantData>());
export const loadUserTenantFailed = createAction('[App][Core] Load tenant data failed');

export const loadUserData = createAction('[App][Core] Load user data');
export const loadUserDataSucceded = createAction('[App][Core] Load user data succeeded', props<UserData>());
export const loadUserDataFailed = createAction('[App][Core] Load user data failed');

export const loadUserById = createAction('[App][Core] Load user by id', props<{ userId: number }>());
export const loadUserByIdSucceded = createAction('[App][Core] Load user by id succeded', props<UserData>());
export const loadUserByIdFailed = createAction('[App][Core] Load user by id failed');

export const setUserGeneralRole = createAction('[App][Core] User general role update', props<{ roleName: string }>());
export const setAuthenticated = createAction('[App][Core] set authenticated', props<{ isAuthenticated: boolean }>());

export const loadAllUserProperties = createAction('[App][Core] Load all user properties');
export const loadAllUserPropertiesSucceeded = createAction(
  '[App][Core] Load all user properties succeeded',
  props<{ properties: RestPropertyModel[] }>()
);
export const loadAllUserPropertiesFailed = createAction('[App][Core] Load all user properties failed');

export const updateTenantSettings = createAction(
  '[App][Core] Update tenant settings',
  props<{ settings: Partial<TenantSettingsModel> }>()
);
export const updateTenantSettingsSucceeded = createAction(
  '[App][Core] Update tenant settings succeeded',
  props<{ settings: TenantSettingsModel }>()
);
export const updateTenantSettingsFailed = createAction(
  '[App][Core] Update tenant settings failed',
  props<{ error: any }>()
);
export const collectAndUpdateTenantSettings = createAction(
  '[App][Core] Collect and Update tenant settings',
  props<{ settings: Partial<TenantSettingsModel>; successMessage?: string }>()
);
